import { ControlProps, components } from "react-select";

import styles from "./select-layout.module.scss";

const Control = (props: ControlProps) => (
  <components.Control
    {...props}
    innerProps={{ ...props.innerProps, id: styles.control }}
  />
);

export default Control;
